module.exports = __webpack_public_path__ + "static/media/updated-icon.68ed84e0.svg";